import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nouser',
  templateUrl: './nouser.component.html',
  styleUrls: ['./nouser.component.css']
})
export class NouserComponent implements OnInit {

  constructor(private router: Router, private msalService: MsalService) { }


  logout() {
    this.msalService.logout();
  }


  ngOnInit() {
  }

}
